import axios from 'axios';
import { useMemo } from 'react';

import { useAuth } from './use-auth';
import { useDoctor } from './use-doctor';

const noAuthorization = [
  'auth/login/',
  'auth/registration/',
  'v1/projects/',
  'auth/password/reset/',
  'auth/password/reset/confirm/',
  'login/magic/',
  'login/request-magic-link/',
];

const useAxios = () => {
  const { auth, setAuth } = useAuth();
  const { lang } = useDoctor();

  return useMemo(() => {
    const apiInstance = axios.create({
      baseURL: import.meta.env.VITE_API_URL,
    });

    apiInstance.interceptors.request.use(
      (config) => {
        if (!config.headers.Authorization) {
          config.headers.Authorization = `Token ${auth}`;
        }
        if (noAuthorization.includes(config.url)) {
          config.headers.Authorization = null;
        }
        config.headers['Accept-Language'] = lang;
        return config;
      },
      (error) => Promise.reject(error)
    );

    apiInstance.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error?.response?.status === 401) {
          setAuth(false);
        }
        return Promise.reject(error);
      }
    );

    apiInstance.event = (event, flow) =>
      apiInstance.post(`v1/events/`, {
        flow,
        event,
      });

    return apiInstance;
  }, [auth, lang, setAuth]);
};

export default useAxios;
